const { toggleScroll } = require( "@/utilities/toggleScroll" );


initDialogListeners();

function initDialogListeners() {
    const triggers = document.querySelectorAll( 'button[data-dialog]' );
    const dialogs = document.querySelectorAll( 'dialog.dialog' );
    const closers = document.querySelectorAll( 'button[data-dialog-close]' );

    triggers.forEach( trigger => {
        trigger.addEventListener( 'click', ( e ) => {
            const dialogName = trigger.getAttribute( 'data-dialog' );
            const dialog = document.querySelector( `dialog#${dialogName}` );
            const asModal = trigger.getAttribute( 'data-is-modal' ) ?? 'true';

            if ( !dialog ) {
                console.warn( 'No dialog with ID: ' + dialogName );
                return;
            }

            openDialog( dialog, asModal === 'true' );
        } );
    } );

    closers.forEach( closer => {
        closer.addEventListener( 'click', ( e ) => {
            const dialog = closer.closest( 'dialog' );
            if ( !dialog ) return;
            closeDialog( dialog );
        } );
    } );

    dialogs.forEach( dialog => {
        dialog.addEventListener( 'close', () => toggleScroll( true ) );
        if ( dialog.classList.contains( 'dialog-show-on-load' ) ) {
            openDialog( dialog );
            dialog.classList.remove( 'dialog-show-on-load' );
        }
    } );
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
export function openDialog( dialog, asModal = true ) {
    asModal ? dialog.showModal() : dialog.show();
    dialog.classList.add( 'dialog-is-open' );
    if ( asModal ) toggleScroll( false );
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
export function closeDialog( dialog ) {
    const closeHandler = ( e ) => {
        if ( e.target !== dialog ) return;
        dialog.close();
        dialog.removeEventListener( 'transitionend', closeHandler );
    };
    dialog.addEventListener( 'transitionend', closeHandler );
    dialog.classList.remove( 'dialog-is-open' );
}